<template>
	<nav class="navbar fixed-bottom">
		<div class="container-fluid justify-content-md-center">

			<div class="col col-4" v-show="location" >

				<button class="btn btn-success btn-sm" v-show="!userIsLoging" @click.stop="doLogin()">LOGAR
					<i class="fa fa-sign-out" aria-hidden="true"></i>
				</button>

				<button class="btn btn-dark btn-sm" v-show="userIsLoging" @click.stop="doLogoff()">DESLOGAR
					<i class="fa fa-sign-out" aria-hidden="true"></i>
				</button>

        <b-dropdown :disabled="!userIsLoging" text="PAUSAR " size="sm" variant="info" left>
          <template v-for="pause in pauses">
            <b-dropdown-item :key="pause.id" @click.stop="doPause(pause.id)">{{pause.id}} {{pause.description}}</b-dropdown-item>
          </template>
        </b-dropdown>

				<b-button v-if="pabx.status == 2" size="sm" v-show="pabx.status == 2" variant="primary" @click.stop="doUnPause()">
					<i class="fa fa-play-circle-o" aria-hidden="true"></i> SAIR DA PAUSA</b-button>
			</div>

			<div class="col auto text-right">
				<label class="pr-2">Agente:
					<span class="badge badge-pill badge-secondary">{{ agent }}</span>
				</label>
				<label class="pr-2">Status:
					<span class="badge badge-pill badge-info">{{ statusDisplay }}</span>
				</label>
				<label class="pr-2" >Ramal:
					<span class="badge badge-pill badge-danger">{{ location || 'N/D' }}</span>
          <a v-show="!location" @click.prevent="reloadPage()" href="#" class="btn btn-sm"><i class="fa fa-refresh"></i></a>
				</label>
			</div>

		</div>
	</nav>
</template>
<style scoped>
nav {
	border-top: 2px solid #555;
	background: #FFF
}
label {
	 color: #555;
}
</style>
<script>

import { mapState } from 'vuex'
import DateFormat from '../../assets/js/utils.date.js';

import VonixPabxService from '../../service/VonixPabxService';
import { Vonix, status } from '../../assets/js/vue-vonix-1.6.js';

const { deslogado, disponivel, emPausa, indisponivel } = status

export default {
	name: 'PabxCard',

	data () {
		return {
      location: '',
			statusDisplay: '',
			loging: false,
      pauses: [],
      vonixPabxService: {},

      intervalInCheck: null,

			pabx: {
        status: 0,
        pauseReason: 0,
				ramal: '',
				vonix: null
			}
		}
	},

  props: ['agent'],

  beforeDestroy(){
    this.$bus.$off('doPause')
    this.$bus.$off('doUnPause')
    this.$bus.$off('exit')
    this.$bus.$off('doHangUp')
  },

	mounted () {
    let PABX_URL = this.$store.state.pabx.url || "http://"
    let [ url ] = PABX_URL.split(":")

		this.vonixPabxService = new VonixPabxService(PABX_URL)
    this.vonix = new Vonix(PABX_URL, this.agent);

    this.$on('onEvent', event => {
      this._logger(this.$store.state.user.matricula, event)
    })

		this.$bus.$on('doDial', data => {
			if (this.pabx.status !== disponivel) {
				this.showAlert(`No momento você não está disponível para efeturar uma nova chamada. Tente novamente`, 'ERRO');
			} else {
				if (data.to.length < 8) {
					this.showAlert('Formato de telefone inválido. Verifique e tente novamente.', 'ERRO');
					return;
				}
				this.doDial(data.to, data.contactName);
			}
		});

		this.$bus.$on('doPause', data => this.doPause(data.pause))
    this.$bus.$on('doUnPause', data => {
      if(!data.condition || (data.condition && data.condition == this.pabx.pauseReason)){
        this.doUnPause()
      }
    })
		this.$bus.$on('exit', data => this.doLogoff())
    this.$bus.$on('doHangUp', data => this.doHangUp(data))

		this.vonix.onDial((call_id, date, queue, from, to, callfilename, contact_name, action_id) => {
      this.statusDisplay = `DISCANDO ${to}`;

			this.$emit('onEvent', {
				eventName: 'onDial',
				callId: call_id,
				date: DateFormat.format(date),
				queue, from, to,
				callfilename, contactName: contact_name,
				actionId: action_id
			});
		});

		this.vonix.onDialAnswer((call_id, date) => {
			this.statusDisplay = 'EM ATENDIMENTO';
			this.pabx.status = indisponivel;

			this.$emit('onEvent', {
				eventName: 'onDialAnswer',
				callId: call_id, date: DateFormat.format(date)
			});
		});

		this.vonix.onDialFailure((call_id, date, cause_id, cause_description) => {
			this.statusDisplay = 'DISPONÍVEL';

			this.$emit('onEvent', {
				eventName: 'onDialFailure',
				callId: call_id,
				date: DateFormat.format(date),
				causeId: cause_id,
				causeDescription: cause_description
			});
		});

		this.vonix.onReceive((call_id, date, queue, from, to, callfilename, contact_name, action_id, additional_data) => {
			this.statusDisplay = 'RECEBENDO CHAMADA';

			this.$emit('onEvent', {
				eventName: 'onReceive',
				callId: call_id,
				date: DateFormat.format(date),
				queue, from, to, callfilename, contactName: contact_name, actionId: action_id, additionalData: JSON.stringify(additional_data)
			});
		});

		this.vonix.onReceiveAnswer((call_id, date, waiting_seconds) => {
			this.statusDisplay = 'EM ATENDIMENTO';

			this.$emit('onEvent', {
				eventName: 'onReceiveAnswer',
				callId: call_id,
				date: DateFormat.format(date),
				waitingSeconds: waiting_seconds
			});
		});

		this.vonix.onReceiveFailure((call_id, date, waiting_seconds) => {
			this.statusDisplay = 'CHAMADA RECUSADA';

			this.$emit('onEvent', {
				eventName: 'onReceiveFailure',
				callId: call_id,
				date: DateFormat.format(date),
				waitingSeconds: waiting_seconds
			});
		});

		this.vonix.onHangUp((call_id, date, cause_id, cause_description) => {
      this.statusDisplay = 'DISPONÍVEL';
      this.pabx.status = disponivel
      this.$store.commit('setPabxStatus', disponivel)

			this.$emit('onEvent', {
				eventName: 'onHangUp',
				callId: call_id,
				date: DateFormat.format(date),
				causeId: cause_id,
				causeDescription: cause_description
			});
		});

		this.vonix.onLogin((date, location) => {
			this.statusDisplay = 'DISPONÍVEL';
      this.pabx.status = disponivel;
      this.$store.commit('setPabxStatus', disponivel)
			this.loging = true;

			this.$emit('onEvent', {
				eventName: 'onLogin',
				date: DateFormat.format(date),
				location
			});

			this.pabx.ramal = location;
			this.statusDisplay = 'CONECTADO';
		});

		this.vonix.onLogoff((date, location, duration) => {
			this.$emit('onEvent', {
				eventName: 'onLogoff',
				date: DateFormat.format(date),
				location,
				duration
			});

			this.pabx.ramal = '';
      this.statusDisplay = `DESLOGADO`;

      this.pabx.status = deslogado
      this.$store.commit('setPabxStatus', deslogado)
		});

		this.vonix.onPause((date, reason) => {
			this.$emit('onEvent', {
				eventName: 'onPause',
				date: DateFormat.format(date),
				reason
			});

			this.statusDisplay = this.getPauseDescription(reason) || `EM PAUSA ${reason}`
      this.pabx.status = emPausa;
      this.pabx.pauseReason = reason
      this.$store.commit('setPabxStatus', emPausa)
		});

		this.vonix.onUnpause((date, reason, duration) => {
			this.statusDisplay = `DISPONÍVEL`;
      this.pabx.status = disponivel;
      this.pabx.pauseReason = 0
      this.$store.commit('setPabxStatus', disponivel)

			if (this.loging)
				this.$emit('onEvent', {
					eventName: 'onUnpause',
					date: DateFormat.format(date),
					reason,
					duration
				});
		});

		this.vonix.onStatus((status, location, since, status_data) => {
			let descriptionStatus = '';
			if (status !== 'OFFLINE')
				this.loging = true;

			switch (status) {
				case 'ONLINE':
					descriptionStatus = 'DISPONÍVEL';
          this.pabx.status = disponivel;
          this.$store.commit('setPabxStatus', disponivel)
					break;
				case 'PAUSED':
					descriptionStatus = this.getPauseDescription(status_data.pause_reason) || 'EM PAUSA';
          this.pabx.status = emPausa;
          this.$store.commit('setPabxStatus', emPausa)
					break;
				case 'OFFLINE':
					descriptionStatus = 'DESLOGADO';
          this.pabx.status = deslogado;
          this.$store.commit('setPabxStatus', deslogado)
					this.loging = false;
					break;
				case 'RINGING':
					descriptionStatus = 'CHAMANDO';
          this.pabx.status = indisponivel;
          this.$store.commit('setPabxStatus', indisponivel)
					break;
				case 'ONTHEPHONE':
					descriptionStatus = 'EM ATENDIMENTO';
					this.$store.commit('setPabxStatus', indisponivel)
					break;
				default:
          this.pabx.status = indisponivel;
          this.$store.commit('setPabxStatus', indisponivel)
					descriptionStatus = status;
			}

			this.pabx.ramal = location;
      this.statusDisplay = descriptionStatus;

      if(this.pabx.status != emPausa) this.clearCheckStatusOn()

			this.$emit('onEvent', {
				eventName: 'onStatus',
				status, location, since, statusData: status_data
			})
		});

		this.vonix.onError((date, action_id, description) => {
			this.statusDisplay = `ERROR`;

			this.$emit('onEvent', {
				eventName: 'onError',
				date: DateFormat.format(date),
				actionId: action_id,
				description
			});
		});

		this.vonix.onConnect((date) => {
			this.statusDisplay = `DISPONÍVEL`;
			this.vonix.doStatus();

			this.$emit('onEvent', {
				eventName: 'onConnect',
				date: DateFormat.format(date)
			});
		});

    this.getPauseReasons()
    this._getLocation()
	},

	methods: {
		emitTest () {
			this.$emit('onEvent', {
				eventName: 'onDial',
				callId: 1987416.1231231,
				date: DateFormat.format(new Date()),
				queue: 'arautospesquisa', from: '2015', to: ''
			});

			setTimeout(() => {
			this.$emit('onEvent', {
				eventName: 'onHangUp'
			});
			}, 1000)
    },

    clearCheckStatusOn() {
      clearInterval(this.intervalInCheck)
    },

    checkStatusOn() {
      this.intervalInCheck = setInterval(() => {
        this.vonix.doStatus()
      }, 5000)
    },

		showAlert (message, title) {
			this.$alert(message, title, { confirmButtonText: 'OK' })
		},

		doDial (to, contactName, queue, billingGroup, actionId) {
			if (this.loging){
        this.vonix.doDial(to, contactName || to, queue || '', billingGroup || 1, actionId);
        this._logger(this.agent, { eventName: 'doDial', location: this.getLocation || '', event: { to, contactName, queue, billingGroup, actionId }})
      }
		},

		doHangUp( data ){
      this.vonix.doHangUp(data.callId)
      this._logger(this.agent, { eventName: 'doHangUp', location: this.getLocation || '', event: data })
		},

		doLogin () {
      this.vonixPabxService.doLogin(this.agent, this.getLocation || '')
      this._logger(this.agent, { eventName: 'doLogin', location: this.getLocation || '' })

			if(this.pauses.length <= 0){
				this.vonixPabxService.getPauseReasons()
			}
		},

		doLogoff () {
			this.loging = false
      this.vonixPabxService.doLogoff(this.agent)
      this._logger(this.agent, { eventName: 'doLogoff', location: this.getLocation || ''})
		},

		doPause (pause) {
			if (this.loging){
        this.vonix.doPause(pause)
        this.checkStatusOn()
        this._logger(this.agent, { eventName: 'doPause', location: this.getLocation || '', pause})
      }
    },

		doUnPause () {
			if (this.loging){
        this.vonix.doUnpause()
        this.clearCheckStatusOn()
        this._logger(this.agent, { eventName: 'doUnpause', location: this.getLocation || ''})
      }
		},

		onClickOnPause (pause) {
			this.vonix.doPause(pause);
		},

		getPauseDescription(reason) {
			return this.pauses.filter(item => item.id == reason).reduce((a, b) => {
				return b.description
			}, '')
		},

		getPauseReasons() {
			this.vonixPabxService.getPauseReasons()
				.then(pauses => this.pauses = pauses.map(pause => {
					pause.description = pause.description.toUpperCase()
					return pause
				}))
    },

    _logger(agent, event) {
      this.$socket.emit('pabx_events', { pabx: 'vonix', agent: agent, event })
    },

		_getLocation () {
      let URLParams = new URLSearchParams(location.search)
      let ramal = URLParams.get('macAddress') || URLParams.get('location')

      if(ramal){
        this.$store.commit('setPabxMacAddress', ramal.replace(/\//g, ''))
        this.location = this.getLocation
      }
		},

    reloadPage(){
      window.location.reload()
    }
	},

	computed: {
    ...mapState({

      getLocation: state => state.pabx.macAddress || ""

    }),

		userIsLoging () {
			return this.loging
		}
	}

}
</script>




// WEBPACK FOOTER //
// PabxCard.vue?3ef3ec7c